/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Error_PermissionInputs */



/**
* | output |
* | --- |
* | "The AI Assistant requires an active Closed Caption Creator subscription or trial." |
*
* @param {Assistant_Error_PermissionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_error_permission = /** @type {((inputs?: Assistant_Error_PermissionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Error_PermissionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'assistant IA nécessite un abonnement ou une période d'essai active à Closed Cap Creator.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für den KI-Assistenten ist ein aktives Abonnement oder eine Testversion von Closed Caption Creator erforderlich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'Assistente AI richiede un abbonamento attivo o una versione di prova di Closed Caption Creator.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для работы ИИ-помощника требуется действующая подписка или пробная версия программы для создания субтитров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Asistente de IA requiere una suscripción o prueba activa a Closed Caption Creator.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AI助手需要有效的字幕创建者订阅或试用版。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIアシスタントを利用するには、有効なクローズドキャプション作成ツールのサブスクリプションまたはトライアルが必要です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई असिस्टेंट के लिए सक्रिय क्लोज्ड कैप्शन क्रिएटर सदस्यता या परीक्षण की आवश्यकता होती है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O Assistente de IA requer uma assinatura ativa ou um período de avaliação do Closed Caption Creator.")
	return /** @type {LocalizedString} */ ("The AI Assistant requires an active Closed Caption Creator subscription or trial.")
});